import { AccordionBody, AccordionHeader, AccordionItem } from "../../Accordion";
import RadioCard from "../../RadioCard";
import ValidatedField from "../../form/ValidatedField";
import {
  RevisorsSectionProps,
  scrollToRefIfNotInView,
} from "../RevisorsErklaering";

export default function RevisorsHandling1(props: RevisorsSectionProps) {
  const { isCompleteHelpers, formikProps, refs, texts, locked } = props;
  const { revisors_handling_1 } = texts;
  const { values, errors, touched } = formikProps;
  return (
    <AccordionItem value="Handling1">
      <AccordionHeader
        sectionStarted={!!values.revisors_handling_1_question}
        sectionComplete={isCompleteHelpers.revisors_handling_1_complete}
        ref={refs.handling_1_ref}
        onClick={() => {
          scrollToRefIfNotInView(refs.introRef);
        }}
      >
        {revisors_handling_1.title}
      </AccordionHeader>
      <AccordionBody>
        <fieldset disabled={locked}>
          <legend className="h5 fw-normal mb-4 lh-base">
            {revisors_handling_1.fieldset_legend}
          </legend>
          <div className="vstack gap-3" role="group">
            <RadioCard
              name={revisors_handling_1.revisors_handling_1_question.id}
              value={
                revisors_handling_1.revisors_handling_1_question
                  .revisors_handling_1_question_alt_1.id
              }
              id={
                revisors_handling_1.revisors_handling_1_question
                  .revisors_handling_1_question_alt_1.id
              }
              text={
                revisors_handling_1.revisors_handling_1_question
                  .revisors_handling_1_question_alt_1.label
              }
            ></RadioCard>

            <RadioCard
              value={
                revisors_handling_1.revisors_handling_1_question
                  .revisors_handling_1_question_alt_2.id
              }
              id={
                revisors_handling_1.revisors_handling_1_question
                  .revisors_handling_1_question_alt_2.id
              }
              name={revisors_handling_1.revisors_handling_1_question.id}
              text={
                revisors_handling_1.revisors_handling_1_question
                  .revisors_handling_1_question_alt_2.label
              }
            >
              <ValidatedField
                touched={
                  touched.revisors_handling_1_question_alt_2_samleklientbankkonti
                }
                error={
                  errors.revisors_handling_1_question_alt_2_samleklientbankkonti
                }
                as="textarea"
                rows={2}
                name={
                  revisors_handling_1
                    .revisors_handling_1_question_alt_2_samleklientbankkonti.id
                }
                placeholder="Samlebankkonti"
                autoComplete="off"
              />
            </RadioCard>
            <RadioCard
              value={
                revisors_handling_1.revisors_handling_1_question
                  .revisors_handling_1_question_alt_3.id
              }
              id={"revisors_handling_1_question_alt_3"}
              name={revisors_handling_1.revisors_handling_1_question.id}
              text={
                revisors_handling_1.revisors_handling_1_question
                  .revisors_handling_1_question_alt_3.label
              }
            >
              <ValidatedField
                as="textarea"
                rows={2}
                name={
                  revisors_handling_1
                    .revisors_handling_1_question_alt_3_samleklientbankkonti.id
                }
                placeholder="Samlebankkonti"
                autoComplete="off"
                touched={
                  touched.revisors_handling_1_question_alt_3_samleklientbankkonti
                }
                error={
                  errors.revisors_handling_1_question_alt_3_samleklientbankkonti
                }
              />
            </RadioCard>
            <RadioCard
              value={
                revisors_handling_1.revisors_handling_1_question
                  .revisors_handling_1_question_alt_4.id
              }
              id={
                revisors_handling_1.revisors_handling_1_question
                  .revisors_handling_1_question_alt_4.id
              }
              name={revisors_handling_1.revisors_handling_1_question.id}
              text={
                revisors_handling_1.revisors_handling_1_question
                  .revisors_handling_1_question_alt_4.label
              }
            >
              <ValidatedField
                touched={touched.revisors_handling_1_question_alt_4_beskrivelse}
                error={errors.revisors_handling_1_question_alt_4_beskrivelse}
                as="textarea"
                name={
                  revisors_handling_1
                    .revisors_handling_1_question_alt_4_beskrivelse.id
                }
                placeholder="Beskrivelse"
                autoComplete="off"
              />
            </RadioCard>
          </div>
        </fieldset>
      </AccordionBody>
    </AccordionItem>
  );
}
